import * as React from 'react';
import { isValidElement } from 'react';
import { isFragment } from 'react-is';
import { FilterableComponent, FilterableObject, useFilteredComponents } from './useFiltered';

export type FilterableChildren<T extends FilterableObject> = FilterableComponent<T> | FilterableComponent<T>[];

const flattenChildren = (children: React.ReactNode) =>
  React.Children.toArray(children).reduce<FilterableComponent<FilterableObject>[]>((acc, node) => {
    if (!node) return acc;
    if (isFragment(node)) {
      acc.push(...flattenChildren(node.props.children));
    } else if (isValidElement<FilterableObject>(node)) {
      acc.push(node);
    }
    return acc;
  }, []);

const useFilteredChildren = <T extends FilterableObject>(children: FilterableChildren<T>) =>
  useFilteredComponents(flattenChildren(children));

export default useFilteredChildren;
